import { useBreakpointValue } from '@chakra-ui/react';

import { logger } from 'src/lib/logger';
import { Avatar, AvatarUpload, useAvatarUpload } from 'src/components/avatar';

import { useIsMobile } from 'src/hooks/use-is-mobile';
import { useRepplAvatarMutation } from '../hooks';

interface AvatarProps {
  rid: string;
  isOwner: boolean;
  isLoading: boolean;
  width?: number;
  height?: number;
  name: string;
  src: string;
}

const RepplAvatar = (props: AvatarProps) => {
  const avatarSize = useBreakpointValue({ base: 72, md: 88 });

  const isMobile = useIsMobile();

  const {
    isLoading: isAvatarLoading,
    mutateAsync: updateAvatar,
  } = useRepplAvatarMutation(props.rid);

  const avatarUpload = useAvatarUpload(async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      await updateAvatar({ data: formData });
    } catch (error) {
      logger.error(error);
    }
  });

  return (
    <div className="relative" style={{ height: 'max-content' }}>
      <div
        className="w-full h-full absolute left-0 top-0 rounded-full"
        style={{ border: '1px solid rgba(255,255,255,0.4)' }}
      />
      <Avatar
        isLoading={props.isLoading}
        width={props.width || avatarSize}
        height={props.height || avatarSize}
        src={props.src}
        name={props.name}
        opacity={isAvatarLoading ? 0.5 : 1}
        wrapperProps={{
          width: props.width || avatarSize,
          height: props.width || avatarSize,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {props.isOwner && (
          <AvatarUpload
            {...avatarUpload}
            loading={isAvatarLoading}
            background="#242526"
            display="flex"
            justifyContent="center"
            alignItems="center"
            width={isMobile ? '24px' : '32px'}
            height={isMobile ? '24px' : '32px'}
          />
        )}
      </Avatar>
    </div>
  );
};
export default RepplAvatar;
